import React from "react";
import Image from "gatsby-image";
import { useTeamPhotos } from "shared/Hooks/About/Team";
import { SocialmonsterImage } from "./SocialmonsterImage";

// icons todo
import VueIcon from "assets/images/technologies/vue.svg";

export const SocialmonsterData = () => {
  const images = SocialmonsterImage();
  const team_images = useTeamPhotos();

  return {
    color: "#020F5C",
    title: "Social monster ",
    seo:
      "Stworzyliśmy własną markę – Social Monster – która skupia się na obsłudze i tworzeniu kampanii w mediach społecznościowych.",
    slug: "social-monster",
    hero: {
      title: "Przerażająco dobry branding.",
      color: "#020F5C",
      background: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"cover"}
          fluid={images.hero.childImageSharp.fluid}
        />
      ),
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.detail.childImageSharp.fluid}
        />
      ),
    },
    list: {
      detail: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.list_detail.childImageSharp.fluid}
        />
      ),
      background: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.list_bg.childImageSharp.fluid}
                />
              ),
    },
    what_we_did: {
      title: "Autorskie rysunki, które wypromują Twoją markę",
      technologies: [
        "Strona WWW",
        "UX Workshops",
        "Identyfikacja wizualna",
        "Brand heros",
      ],
      text:
        "Stworzyliśmy własną markę – Social Monster – która skupia się na obsłudze i tworzeniu kampanii w mediach społecznościowych. Nasze zadania opierały się na stworzeniu strategii marketingowej, identyfikacji wizualnej oraz strony internetowej. Zadaniem Social Monster jest projektowanie unikalnych grafik, które w nieszablonowy sposób przedstawią markę.",
      list: [
        "Stworzyliśmy brand heroes",
        "Opracowaliśmy branding dla agencji reklamowej",
        "Prowadziliśmy profile w mediach społecznościowych",
        "Wykonaliśmy grafiki na potrzeby social media",
        "Pozyskiwaliśmy klientów poprzez Social Media Ads",
      ],
    },
    headers: {
      first: "Nowa jakość grafik w social mediach",
    },
    content_images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.soc_1.childImageSharp.fluid}
        />
      ),
    },
    full_images: {
      first: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_1f.childImageSharp.fluid}
          />
        ),
      },
      second: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_2f.childImageSharp.fluid}
          />
        ),
      },
      third: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_3f.childImageSharp.fluid}
          />
        ),
      },
      fourth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_4f.childImageSharp.fluid}
          />
        ),
      },
      fifth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_5f.childImageSharp.fluid}
          />
        ),
      },
      sixth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_6f.childImageSharp.fluid}
          />
        ),
      },
      seventh: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_7f.childImageSharp.fluid}
          />
        ),
      },
      eighth: {
        image: (
          <Image
            alt=""
            objectPosition={"center"}
            objectFit={"contain"}
            fluid={images.soc_8f.childImageSharp.fluid}
          />
        ),
      },
    },
    text_boxes: {
      first: {
        title: "Strasznie przyjazne potworki ",
        text:
          "W projekcie systematycznie przewija się motyw Monsterów - przyjemnych potworków, które symbolizują najpopularniejsze social media. Cała strona utrzymana jest w klimacie strachów i potworów, które sprawiają pozytywne wrażenie. ",
      },
      second: {
        title: " Ilustracje na każdą okazję",
        text:
          "Social Monster to projekt, którego zadaniem jest dostarczanie pomysłowych i ciekawych grafik do wykorzystania w social mediach. To, co go wyróżnia, to nieszablonowe podejście do tematu i przeraźliwie kreatywne pomysły!",
      },
    },
    technologies: {
      title: "Przykładowy dłuższy nagłówek dotyczący technologii",
      text: (
        <>
          Współpracę z agencją InteractiveVision wysoko cenimy za zaangażowanie,
          elastyczność oraz kompleksowość usług. Zawsze mogliśmy liczyć na
          profesjonalne doradztwo w zakresie planowanych działań oraz
          kreatywność.
          <br />
          <br />
          Dotychczasowa współpraca z tą firmą pozwala nam na rekomendowanie jej
          usług innym.
        </>
      ),
      icons: [
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
        { title: "Vue", icon: VueIcon },
      ],
    },
    marketing: {
      counts: [
        {
          count: "20%",
          title: "Zwiększona konwersja",
        },
        {
          count: 2000,
          title: "Polubień w 1 miesiąc",
        },
        {
          count: "53%",
          title: "zwiększona sprzedaż",
        },
      ],
      team: [
        {
          name: "Patrycja Bilska",
          position: "Project Manager",
          image: (
            <Image alt="" fluid={team_images.Patrycja.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Skórka",
          position: "Frontend Developer",
          image: (
            <Image alt="" fluid={team_images.Rafal.childImageSharp.fluid} />
          ),
        },
        {
          name: "Patryk Białas",
          position: "Graphic designer",
          image: (
            <Image alt="" fluid={team_images.Patryk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Rafał Krawiec",
          position: "Backend Developer",
          image: (
            <Image alt="" fluid={team_images.Krawczyk.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Żmuda",
          position: "Marketing Specialist",
          image: (
            <Image alt="" fluid={team_images.Kuba.childImageSharp.fluid} />
          ),
        },
        {
          name: "Jakub Furman",
          position: "Sales Manager",
          image: (
            <Image alt="" fluid={team_images.Furman.childImageSharp.fluid} />
          ),
        },
      ],
    },
  };
};
